import React from "react";
import "./Background.css";
function Background() {
  return (
    <>
      <div className="context"></div>
      <div className="area">
        <ul className="squares">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </>
  );
}

export default Background;
